import Vue from 'vue'
import VueRouter from 'vue-router'
import Search from '../views/Search.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/user-login',
    component: Login
  },
  // Home path removed so user will start at /
  // {
  //   path: '/',
  //   redirect: '/home', // Redirect root to main protected route
  //   // meta: {
  //   //   requiresAuth: true
  //   // },
  // },
  {
    path: '/',
    component: Home,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/',
        component: Search
      },
      {
        path: '/resolution/:id?',
        component: () => import('../views/Resolution.vue'),
        props: true
      },
      {
        path: '/help',
        component: () => import('../views/Help.vue')
      },
      {
        path: '/history',
        component: () => import('../views/History.vue')
      },
      {
        name: "casesCsv",
        path: "api/reports/csv/cases"
      },
      {
        path: '/settings',
        component: () => import('../views/Settings.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/settings/Profile.vue')
          },
          {
            path: '/users',
            component: () => import('../views/settings/Users.vue')
          },
          {
            path: '/account',
            component: () => import('../views/settings/Account.vue')
          },
          // {
          //   path: '/invoices',
          //   component: () => import('../views/settings/Invoices.vue')
          // },

          {
            path: '/compliance',
            component: () => import('../views/settings/Compliance.vue')
          }
        ]
      },
      {
        path: '/casegroups',
        component: () => import('../views/CaseGroups.vue')
      },
      {
        path: '/casemanager/:id?',
        component: () => import('../views/CaseManager.vue'),
        props: true
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {

  /**
   * NOTE This was an attempt to avoid navigation duplication that happen when multiple
   * API calls are caught by axios unauthorized interceptor and are redirected to the login page
   * while already on the login page. This is now handled in the interceptor itself. 
   */
  // if(to === from){
  //   console.log("Cancelling nav: " + to)
  //   return false
  // }

  const authenticated = store.getters.isAuthenticated
  const profile = store.getters.getUserProfile

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authenticated) {
      next('/user-login')
    } else if (!profile) {
      // Optional: If user data is required but missing (edge case), force re-validation or logout
      next('/user-login')
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router